var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCareer = function SvgCareer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeWidth: 1.5,
    d: "M9.75 13.5v15a5 5 0 1 0 10 0V11a5 5 0 0 1 10 0v7.5m-20-5a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ECDC4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30 21.5c-2.484 0-4.5 1.918-4.5 4.281 0 2.719 3 7.027 4.102 8.516a.492.492 0 0 0 .796 0C31.5 32.809 34.5 28.502 34.5 25.78c0-2.363-2.016-4.281-4.5-4.281Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ECDC4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30 27.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  })));
};
export default SvgCareer;